import * as actionTypes from "../../constants/actionTypes";
import * as methods from "../../constants/methods";
import * as handlers from "../../constants/handlers";
import * as resultCodes from "../../constants/resultCodes";
import * as settings from "../../constants/settings";
import * as messageHelper from "../../helpers/messageHelper";
import * as modelHelper from "../../helpers/modelHelper";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.GET_DIFFERENCE_DETAIL:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            if (
                state.formula[tabId] === undefined ||
                state.formula[tabId].statisticsId === null ||
                state.formula[tabId].spectralData === null
            ) {
                return [
                    {
                        type: actionTypes.QC_SAVE_SPECTRAL_DIFFERENCE,
                        payload: {
                            tabId: tabId,
                            result: {
                                [settings.CIE_LAB_1976]: response.data[settings.CIE_LAB_1976_RESPONSE],
                                [settings.CIE_LAB_2000]: response.data[settings.CIE_LAB_2000_RESPONSE],
                                [settings.CMC]: response.data[settings.CMC_RESPONSE],
                                metamerism: response.data.metamerism
                            }
                        }
                    }
                ];
            }

            let colorDifferenceData = modelHelper.mapColorDifferenceToObject(
                response.data[settings.CIE_LAB_1976_RESPONSE],
                response.data[settings.CIE_LAB_2000_RESPONSE],
                response.data[settings.CMC_RESPONSE],
                response.data.metamerism
            );

            return [
                {
                    type: actionTypes.QC_SAVE_SPECTRAL_DIFFERENCE,
                    payload: {
                        tabId: tabId,
                        result: {
                            [settings.CIE_LAB_1976]: response.data[settings.CIE_LAB_1976_RESPONSE],
                            [settings.CIE_LAB_2000]: response.data[settings.CIE_LAB_2000_RESPONSE],
                            [settings.CMC]: response.data[settings.CMC_RESPONSE],
                            metamerism: response.data.metamerism
                        }
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_SET_STATISTIC_COLOR_DIFFERENCE,
                        params: {
                            colorStatsId: state.formula[tabId].statisticsId,
                            sampleReflData: state.formula[tabId].spectralData.spectral,
                            colorDifference: response.data,
                            qualityControl: colorDifferenceData.qualityControl(
                                state.settings.qualityControlDifference,
                                state.settings.qualityControlMetamerism,
                                state.settings.qualityControlDeltaE,
                                state.settings.qualityControlDeltaL,
                                state.settings.qualityControlDeltaA,
                                state.settings.qualityControlDeltaB
                            )
                        }
                    },
                    method: handlers.SET_STATISTIC_COLOR_DIFFERENCE,
                    tabId: tabId
                }
            ];
        case handlers.SET_STATISTIC_COLOR_DIFFERENCE:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.STATISTICS_LIST_UPDATE,
                    payload: {
                        tabId: tabId
                    }
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
